import { render, staticRenderFns } from "./CeisaBarangTable.vue?vue&type=template&id=97ef74be&"
import script from "./CeisaBarangTable.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports